import { sessionConstants } from '../constants';

export function sessionHistoryStatus (state = {}, action) {
    switch (action.type) {
      case sessionConstants.SESSION_HISTORY_STATUS_REQUEST:
        return { 
          loading:true
         };
      case sessionConstants.SESSION_HISTORY_STATUS_SUCCESS:  
      return {
          ...state,
          sessionStatus: true,
          loading:false,
        };
      case sessionConstants.SESSION_HISTORY_STATUS_FAILURE:
        return {
          error: false,
          loading:false
        };
      default:
        return state
    }
  }


// WEBPACK FOOTER //
// ./src/store/reducers/sessionHistoryStatus.reducer.js